
import { Component, Vue, Watch } from "vue-property-decorator";
import FormBase from "@/lib/view-base/formbase";
import { CarouselService, CreateCarouselDto } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
import imgOrVideo from "@/components/uploader/imgAndVideo.vue"
import ImageUploader from '@/components/uploader/imageUploader.vue'
import PreViewDialog from "../components/previewDialog.vue";

@Component({
    name: "CreateProduct",
    components: {
        SelectTree, imgOrVideo, ImageUploader, PreViewDialog
    },
})
export default class CreateProduct extends FormBase {
    carouse = new CreateCarouselDto();
    carouseService: CarouselService = new CarouselService();

    productCategoryType: any = [];
    options=[ // 下拉选项数组
        { label: '滚动图', value: '1' },
        { label: '直播图', value: '2' },
        // 可以继续添加更多选项
    ]
    rules: object = {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        productId: [
            { required: true, message: "请选择选择产品", trigger: "blur" },
        ],
        // integral: [
        //     { required: true, message: "请输入赠送积分", trigger: "blur" },
        // ],
        // IsFree: [
        //     { required: true, message: "是否包邮", trigger: "blur" },
        // ],

        introduction: [],
        isRegisterd: [],
        organizationUnitId: [],
    };
    defaultProps = {
        parent: "parentId", // 父级唯一标识
        value: "id", // 唯一标识
        label: "displayName", // 标签显示
        children: "children",
    };
    IsFree = 1

    tableData: []

    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    productImg = ''
    mounted() {

        this.initProduct();

    }

    created() { }
    async submitExecute(): Promise<void> {
        this.carouse.orderIndex = 1;
        await this.carouseService.create(this.carouse);
    }
    handleSuccess(response, file, fileList) {
        this.carouse.p_Path = response.result.url
    }
    handleFaceUpladSuccess(url) {
        this.carouse.p_Path =url
        debugger
        console.log( this.carouse)
        // this.$set(this.model, 'coverImageUrl', url)
    }

    getAuthImg(img){
      return (this as any).$aes.imgAddAuth(img)
    }

    handleimageSuccess(url) {
        this.carouse.p_Path = (this as any).$aes.imgAddAuth(url)
    }



    //获取商品分类的数据
    initProduct() {
        var _that = this;
        this.carouseService.getProductAll().then(res => {
            _that.productCategoryType = res;
        });


    }

}
